import { Validator } from '@vista-digital/validator';
import { filmWatchlistButtonEventsValidator } from '../../watchlist-button/types/events';
import { defaultFilmThumbnailCdnOptions, filmThumbnailCdnOptionsValidator } from './cdn-options';
import { defaultFilmThumbnailConfig, filmThumbnailConfigValidator } from './config';
export const defaultFilmThumbnailProps = {
    config: defaultFilmThumbnailConfig,
    events: {},
    cdnOptions: defaultFilmThumbnailCdnOptions
};
export const filmThumbnailPropsValidator = Validator.object({
    config: filmThumbnailConfigValidator,
    events: filmWatchlistButtonEventsValidator,
    cdnOptions: filmThumbnailCdnOptionsValidator
});
//# sourceMappingURL=props.js.map